import { down } from "styled-breakpoints"
import { useBreakpoint } from "styled-breakpoints/react-styled";

import { MainMenuItem } from "@interia/common/hooks/useMainMenu"

const useParentMenu = (): MainMenuItem[] => {
  const mobile = useBreakpoint(down('lg'));

  if (mobile) {
    return [
      { title: 'Strona główna', key: 'strona-glowna', url: `${process.env.GATSBY_OFIRMIE_URL}`, blank: false, outlined: false, border: '#001273', external: true, background: '#ffffff' },
      { title: 'Start', key: 'start', url: '/', blank: false, outlined: false, border: '#001273', external: false },
      { title: 'Dlaczego my?', key: 'dlaczego-my', url: '/dlaczego-my', blank: false, outlined: false, border: '#054195', external: false },
      { title: 'Proces rekrutacji', key: 'proces-rekrutracji', url: '/#proces-rekrutacji', blank: false, outlined: false, border: '#90D0F2', external: true },
      { title: 'Praktyki i staże', key: 'praktyki-i-staze', url: '/praktyki-i-staze', blank: false, outlined: false, border: '#053A81', external: false },
      { title: 'Aktualne oferty pracy', key: 'aktualne-oferty-pracy', url: '/aktualne-oferty-pracy', blank: false, outlined: true, external: false, background: '#20BBFC' }
    ]
  } else {
    return [
      { title: 'O nas', key: 'o-nas', url: `${process.env.GATSBY_OFIRMIE_URL}/o-nas`, blank: false, outlined: false, border: '#001273', external: false },
      { title: 'Nasze marki', key: 'nasze-marki', url: `${process.env.GATSBY_OFIRMIE_URL}/nasze-marki`, blank: false, outlined: false, border: '#054195', external: false },
      {
        title: 'Dla mediów', key: 'dla-mediow', url: '/', blank: false, outlined: false, border: '#00DFB8', external: false, children: [
          { title: 'Aktualności', key: 'aktualnosci', url: `${process.env.GATSBY_OFIRMIE_URL}/aktualnosci/1`, blank: false, outlined: false, border: '#054195', external: false },
          { title: 'Materiały do pobrania', key: 'materialy-do-pobrania', url: `${process.env.GATSBY_OFIRMIE_URL}/materialy-do-pobrania`, blank: false, outlined: false, border: '#054195', external: false },
        ]
      },
      { title: 'Interia extra', key: 'interia-extra', url: 'https://extra.interia.pl/', blank: true, outlined: false, border: '#90D0F2', external: true },
      { title: 'Kontakt', key: 'kontakt', url: `${process.env.GATSBY_OFIRMIE_URL}/kontakt`, blank: false, outlined: false, border: '#053A81', external: false },
      { title: 'Kariera', key: 'kariera', url: '', blank: false, outlined: true, external: true, background: '#F60B46', border: undefined }
    ]
  }


}

export default useParentMenu